import { render } from "./ModalMissingPlatformSubscription.vue?vue&type=template&id=53b4e01b"
import script from "./ModalMissingPlatformSubscription.vue?vue&type=script&lang=js"
export * from "./ModalMissingPlatformSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__